module.exports = __webpack_public_path__ + "assets/71da2b46d515eff342b8fc90e6a75b68.png";